import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ProjectService} from '../../../shared/services/project/project.service';
import {environment} from '../../../../environments/environment';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {TranslateService} from '@ngx-translate/core';
import {faSmile, faSadTear} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-project-last-measure',
  templateUrl: './project-last-measure.component.html',
  styleUrls: ['./project-last-measure.component.css']
})
export class ProjectLastMeasureComponent implements OnInit {

  public displayedColumns: string[] = ['id', 'name', 'last_measure_date', 'active'];
  public locationsList: MatTableDataSource<any>;
  public locations: any[] = [];
  public isLoading: boolean = true;
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  public faTimes = faTimes;
  public activeLocationOnly = true;
  public faSmile = faSmile;
  public faSadTear = faSadTear;
  private injectedData: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private projectService: ProjectService,
              private translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.injectedData = data;
  }

  ngOnInit() {
    this.initTable();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.locationsList.filter = filterValue;
  }

  getActiveTextForSlider() {
    let active: string = '';
    let all: string = '';
    this.translate.get('ACTIVE_LOCATIONS_ONLY').subscribe((text: string) => {
      active = text;
    });
    this.translate.get('ALL_LOCATIONS').subscribe((text: string) => {
      all = text;
    });
    return this.activeLocationOnly ? active : all;
  }

  activeOrInactiveLocation() {
    this.activeLocationOnly = !this.activeLocationOnly;
    this.initTable();
  }

  initTable() {
    this.isLoading = true;
    this.projectService.getProject(this.injectedData.idProject, 'last_measure')
      .subscribe(
        (data: any) => {
          if (!this.activeLocationOnly) {
            this.locationsList = new MatTableDataSource(data.project_last_measures);
            this.locationsList.sort = this.sort;
            this.locationsList.paginator = this.paginator;
            this.isLoading = false;
          } else {
            const tempLocList: any = [];
            data.project_last_measures.forEach((d) => {
              if (d.active) {
                tempLocList.push(d);
              }
            });
            this.locationsList = new MatTableDataSource(tempLocList);
            this.locationsList.sort = this.sort;
            this.locationsList.paginator = this.paginator;
            this.isLoading = false;

          }
        }
        ,
        error2 => {
          this.isLoading = false;
        }
      );
  }
}
